import { defineMessages } from 'react-intl';

export default defineMessages({
  editAction: {
    id: 'frontbucket.repository.source.editAction',
    description: 'Action to edit a file',
    defaultMessage: 'Edit',
  },
  editDisabledReasonNoPerm: {
    id: 'frontbucket.repository.source.file.editDisabledReasonNoPerm',
    description: `Tooltip displayed when hovering over a disabled file edit button if the user has no write permission`,
    defaultMessage: `You do not have permission to edit.`,
  },
  editDisabledReasonLFS: {
    id: 'frontbucket.repository.source.file.editDisabledReasonLFS',
    description: `Tooltip displayed when hovering over a disabled file edit button if it's an LFS file`,
    defaultMessage: `You can't edit files in Large File Storage.`,
  },
  editDisabledReasonNonHead: {
    id: 'frontbucket.repository.source.file.editDisabledReasonNonHead',
    description: `Tooltip displayed when hovering over a disabled file edit button if it's being viewed on a commit that isn't the HEAD of a branch`,
    defaultMessage: 'You can only edit the head of a branch.',
  },
  editDisabledReasonNonText: {
    id: 'frontbucket.repository.source.file.editDisabledReasonNonText',
    description: `Tooltip displayed when hovering over a disabled file edit button if it's an image or binary file`,
    defaultMessage: 'You can only edit text files.',
  },
  editDisabledReasonAnonymousUser: {
    id: 'frontbucket.repository.source.file.editDisabledReasonAnonymousUser',
    description: `Tooltip displayed when hovering over a disabled file edit button if the user is not logged in`,
    defaultMessage: 'Log in to edit this file.',
  },
  fileEditorMenuLabel: {
    id: 'frontbucket.repository.source.file.actions.editor.label',
    description: 'Label for default Connect file editor dropdown menu',
    defaultMessage: 'Default File Editor',
  },
  fileViewerMenuLabel: {
    id: 'frontbucket.repository.source.file.actions.viewer.label',
    description: 'Label for default Connect file viewer dropdown menu',
    defaultMessage: 'Default File Viewer',
  },
});
